const modelNames = [
  'companies',
  'brands',
  'salesRegions',
  'lensRefractions',
  'lensDesigns',
  'lensProgDists',
  'lensBlanks',
  'lensCoatings',
  'pricebooks',
  'staffers',
  'customerGroups',
  'customers',
  'suppliers',
  'products',
  'priceRanges',
  'prices',
  'purchaseOrders',
  'salesOrders',
  'externalProducts',
  'rangeEditor',
]

const models = { }
modelNames.forEach(name => {
  models[name] = require(`./${name}.js`)
})

module.exports = models



// WEBPACK FOOTER //
// ./src/models/index.js